import React from 'react';
import './style.css';


const AuthBackgroundComponent = () => {
    return(
        <div className='pos-abs w-100 h-100 flex js-c al-it-c min-height'>
            <div className='auth-layout'>
                <div className="copyright">Copyright © 2021 Qognify, Inc.</div>
                <h3 className='auth-title'> Qognify Web Client {window.VARIABLES.version}</h3>
            </div>
        </div>
    )
};

export default AuthBackgroundComponent